import React from 'react';
import { tokens, ProgressBar } from '@welbe/web-design-system';

import { BarInfo } from 'Views/Campaigns/components/Campaign/Tabs/Results/components/GeneralRisk/components/BarInfo/BarInfo';
import {
	Container,
	ContainerContent,
	ContainerHeader,
	ProgressContainer,
	ContainerContentDomain,
	ContainerHeaderDomain,
	ContainerDivision,
	Line,
	ContainerTitle,
	BadgeContainer,
} from './CardDomain.styles';

interface CardDomainProps {
	category: any;
}

export const CardDomain = ({ category }: CardDomainProps): JSX.Element => {
	return (
		<Container>
			<ContainerContent>
				<ProgressContainer>
					<ProgressBar
						percentValue={100}
						isDonut
						donutSize="82px"
						hasLabel
						labelText={category.risk.name}
						labelColor={tokens.color_gray_dark}
						labelFontSize={category.risk.name === 'Muy alto' ? '9px' : '14px'}
						progressColor={category.risk.color}
					/>
				</ProgressContainer>
				<ContainerHeader>
					<h3>{category.name}</h3>
					<p>Categoría</p>
				</ContainerHeader>
				<BarInfo risks={category.answerRisks} />
			</ContainerContent>
			{category.domains.map((domain: any) => (
				<ContainerContentDomain key={domain.id}>
					<ContainerHeaderDomain>
						<ContainerDivision>
							<Line />
							<p>Dominio</p>
						</ContainerDivision>
						<ContainerTitle>
							<h3>{domain.name}</h3>
							<BadgeContainer color={domain.risk.color}>
								{domain.risk.name}
							</BadgeContainer>
						</ContainerTitle>
					</ContainerHeaderDomain>
					<BarInfo risks={domain.answerRisks} />
				</ContainerContentDomain>
			))}
		</Container>
	);
};
